import { t } from "i18next";
import { toast } from "sonner";
import { emailRegex } from "../../../utils/constants/Email";
import { passwordRegex } from "../../../utils/constants/Password";
import {
  DataActiveStatusEnum,
  IData,
} from "../../../views/admin/Category/types";
import {
  IData as IRetailerSubCategory,
 
} from "../../../views/admin/retailer-category/types";
import { IData as IGroupProduct } from "../../../views/admin/group-product/types";
import { IData as IGroupData } from "../../../views/admin/group/types";
import {
  IData as IPackage,
  PackageTypeEnum,
} from "../../../views/admin/package/types";
import { IData as IProduct } from "../../../views/admin/product/types";
import { IData as IRetailerProduct } from "../../../views/admin/retailer-product/types";
import { IData as INews } from "../../../views/admin/campaign-news/types";
import { IData as ICampaign } from "../../../views/admin/campaign/types";
import { IData as IStoreData } from "../../../views/admin/store/types";
import { IData as IRetailer } from "../../../views/admin/retailer/types";
import { IData as IUser } from "../../../views/admin/user/types";
import {
  IData as ISubCategory,
  TypeEnum,
} from "../../../views/admin/sub-category/types";
import { ILogin, IPassword } from "../../../views/auth/types";

export const LoginValidation = (data: ILogin) => {
  if (data.email.length == 0) {
    toast.error(t("login.validation.email"));
    return false;
  }
  if (data?.email?.length > 0 && !emailRegex.test(data?.email)) {
    toast.error(t("login.validation.invalidEmail"));
    return false;
  }
  if (data?.password?.length == 0) {
    toast.error(t("login.validation.password"));
    return false;
  }
  if (data?.password?.length > 0 && !passwordRegex.test(data?.password)) {
    toast.error(t("login.validation.invalidPassword"));
    return false;
  }
  return true;
};
export const passwordValidation = (data: IPassword) => {
  if (data.password?.length == 0) {
    toast.error(t("login.validation.password"));
    return false;
  }
  if (data?.password?.length > 0 && !passwordRegex.test(data?.password)) {
    toast.error(t("login.validation.invalidPassword"));
    return false;
  }
  if (data?.confirmPassword?.length == 0) {
    toast.error(t("login.validation.confirmPassword"));
    return false;
  }
  if (
    data?.confirmPassword?.length > 0 &&
    !passwordRegex.test(data?.confirmPassword)
  ) {
    toast.error(t("login.validation.invalidConfirmPassword"));
    return false;
  }
  if (data?.password !== data?.confirmPassword) {
    toast.error(t("login.validation.passwordNotMatch"));
    return false;
  }
  return true;
};

export const categoryValidation = (form: IData) => {
  if (form?.title?.length == 0) {
    toast.error(t("common.validation.title"));
    return false;
  }
  if (form?.featuredImage?.length == 0) {
    toast.error(t("common.validation.featuredImage"));
    return false;
  }
  if (form?.status == DataActiveStatusEnum.Null) {
    toast.error(t("common.validation.status"));
    return false;
  }
  return true;
};
export const retailerCategoryValidation = (form: IRetailerSubCategory) => {
  if (form?.title?.length == 0) {
    toast.error(t("common.validation.title"));
    return false;
  }

  if (form?.status == DataActiveStatusEnum.Null) {
    toast.error(t("common.validation.status"));
    return false;
  }
  return true;
};


export const subCategoryValidation = (form: ISubCategory) => {
  if (form?.title?.length == 0) {
    toast.error(t("common.validation.title"));
    return false;
  }
  if (form?.type === TypeEnum.Null) {
    toast.error(t("product.validation.type"));
    return false;
  }
  if (form?.categoryId?.length === 0) {
    toast.error(t("product.validation.category"));
    return false;
  }
  if (form?.featuredImage?.length == 0) {
    toast.error(t("common.validation.featuredImage"));
    return false;
  }
  if (form?.status == DataActiveStatusEnum.Null) {
    toast.error(t("common.validation.status"));
    return false;
  }
  return true;
};
export const groupValidation = (form: IGroupData) => {
  if (form?.title?.length == 0) {
    toast.error(t("common.validation.title"));
    return false;
  }
  if (form?.status == DataActiveStatusEnum.Null) {
    toast.error(t("common.validation.status"));
    return false;
  }
  return true;
};
export const productValidation = (form: IProduct) => {
  if (form.title?.length == 0) {
    toast.error(t("common.validation.title"));
    return false;
  }
  if (form.code?.length == 0) {
    toast.error(t("product.validation.code"));
    return false;
  }
  if (form.price?.length == 0) {
    toast.error(t("product.validation.price"));
    return false;
  }
  if (form.taxRate?.length == 0) {
    toast.error(t("product.validation.taxRate"));
    return false;
  }
  if (form.shipmentCapacity?.length == 0) {
    toast.error(t("product.validation.shipmentCapacity"));
    return false;
  }
  if (form.subCategoryId?.length === 0) {
    toast.error(t("product.validation.subCategory"));
    return false;
  }
  if (form.size?.length == 0) {
    toast.error(t("product.validation.size"));
    return false;
  }
  if (form.shortDescription?.length == 0) {
    toast.error(t("product.validation.shortDescription"));
    return false;
  }
  if (form.longDescription?.length == 0) {
    toast.error(t("product.validation.longDescription"));
    return false;
  }
  if (form?.status == DataActiveStatusEnum.Null) {
    toast.error(t("common.validation.status"));
    return false;
  }
  if (form?.featuredImage?.length === 0) {
    toast.error(t("common.validation.featuredImage"));
    return false;
  }
  if (form?.images?.length === 0) {
    toast.error(t("common.validation.file"));
    return false;
  }
  if (form?.allergicImages?.length === 0) {
    toast.error(t("common.validation.allergicFile"));
    return false;
  }
  if (form?.stickers?.length === 0) {
    toast.error(t("common.validation.stickersFile"));
    return false;
  }
  return true;
};
export const packageValidation = (form: IPackage) => {
  if (form.title?.length == 0) {
    toast.error(t("common.validation.title"));
    return false;
  }

  if (form.price?.length == 0) {
    toast.error(t("product.validation.price"));
    return false;
  }
  if (form.taxRate?.length == 0) {
    toast.error(t("product.validation.taxRate"));
    return false;
  }
  if (form?.type === PackageTypeEnum.Null) {
    toast.error(t("product.validation.type"));
    return false;
  }
  if (form.subCategoryId?.length === 0) {
    toast.error(t("product.validation.subCategory"));
    return false;
  }
  if (form?.status == DataActiveStatusEnum.Null) {
    toast.error(t("common.validation.status"));
    return false;
  }
  if (form?.featuredImage?.length === 0) {
    toast.error(t("common.validation.featuredImage"));
    return false;
  }
  if (form?.images?.length === 0) {
    toast.error(t("common.validation.file"));
    return false;
  }
  if (form?.allergicImages?.length === 0) {
    toast.error(t("common.validation.allergicFile"));
    return false;
  }
  if (form?.stickers?.length === 0) {
    toast.error(t("common.validation.stickersFile"));
    return false;
  }


  return true;
};
export const retailerProductValidation = (form: IRetailerProduct) => {
  if (form.title?.length == 0) {
    toast.error(t("common.validation.title"));
    return false;
  }
  if (form.code?.length == 0) {
    toast.error(t("product.validation.code"));
    return false;
  }
  if (form.price?.length == 0) {
    toast.error(t("product.validation.price"));
    return false;
  }
  if (form.sellingPrice?.length == 0) {
    toast.error(t("product.validation.sellingPrice"));
    return false;
  }
  if (form.taxRate?.length == 0) {
    toast.error(t("product.validation.taxRate"));
    return false;
  }
  if (form.shipmentCapacity?.length == 0) {
    toast.error(t("product.validation.shipmentCapacity"));
    return false;
  }

  if (form.size?.length == 0) {
    toast.error(t("product.validation.size"));
    return false;
  }
  if (form?.categoryId?.length == 0) {
    toast.error(t("product.validation.category"));
    return false;
  }
  if (form.shortDescription?.length == 0) {
    toast.error(t("product.validation.shortDescription"));
    return false;
  }
  if (form.longDescription?.length == 0) {
    toast.error(t("product.validation.longDescription"));
    return false;
  }
  if (form?.status == DataActiveStatusEnum.Null) {
    toast.error(t("common.validation.status"));
    return false;
  }
  if (form?.featuredImage?.length === 0) {
    toast.error(t("common.validation.featuredImage"));
    return false;
  }
  if (form?.images?.length === 0) {
    toast.error(t("common.validation.file"));
    return false;
  }
  // if (form?.allergicImages?.length === 0) {
  //   toast.error(t("common.validation.allergicFile"));
  //   return false;
  // }
  // if (form?.stickers?.length === 0) {
  //   toast.error(t("common.validation.stickersFile"));
  //   return false;
  // }
  return true;
};
export const groupProductValidation = (form: IGroupProduct) => {
  if (form.title?.length == 0) {
    toast.error(t("common.validation.title"));
    return false;
  }
  if (form.groupId?.length === 0) {
    toast.error(t("product.validation.group"));
    return false;
  }
  if (form?.status == DataActiveStatusEnum.Null) {
    toast.error(t("common.validation.status"));
    return false;
  }
  if (form?.featuredImage?.length === 0) {
    toast.error(t("common.validation.featuredImage"));
    return false;
  }
  
  return true;
};
export const newsValidation = (form: INews) => {
  if (form?.title?.length == 0) {
    toast.error(t("news.validTitle"));
    return false;
  }
  if (form?.description?.length == 0) {
    toast.error(t("news.validDescription"));
    return false;
  }
  if (form?.link?.length == 0) {
    toast.error(t("news.validLink"));
    return false;
  }
  if (form?.status == DataActiveStatusEnum.Null) {
    toast.error(t("common.validation.status"));
    return false;
  }
  return true;
};
export const campaignValidation = (form: ICampaign) => {
  if (form?.title?.length == 0) {
    toast.error(t("common.validation.title"));
    return false;
  }
  if (form?.link?.length == 0) {
    toast.error(t("news.validLink"));
    return false;
  }
  if (form?.featuredImage?.length == 0) {
    toast.error(t("common.validation.featuredImage"));
    return false;
  }
  if (form?.status == DataActiveStatusEnum.Null) {
    toast.error(t("common.validation.status"));
    return false;
  }
  return true;
};
export const storeValidation = (form: IStoreData) => {
  if (form?.title?.length == 0) {
    toast.error(t("common.validation.title"));
    return false;
  }
  if (form?.status == DataActiveStatusEnum.Null) {
    toast.error(t("common.validation.status"));
    return false;
  }
  return true;
};

export const retailerUpdateValidation = (form: IRetailer) => {
  if (!form?.status || form?.status?.length == 0) {
    toast.error(t("common.validation.status"));
    return false;
  }
  if (!form?.importantStatus || form?.importantStatus?.length == 0) {
    toast.error(t("common.validation.importantStatus"));
    return false;
  }
  if (!form?.shippingFreeStatus || form?.shippingFreeStatus?.toString().length == 0) {
    toast.error(t("common.validation.shippingFreeStatus"));
    return false;
  }
  return true;
};

export const userUpdateValidation = (form: IUser) => {
  if (!form?.status || form?.status?.length == 0) {
    toast.error(t("common.validation.status"));
    return false;
  }
  if (!form?.importantStatus || form?.importantStatus?.length == 0) {
    toast.error(t("common.validation.importantStatus"));
    return false;
  }
  return true;
};